/** "2026-10-28" → "onsdag 28 oktober". Returns the input if it can't be parsed. */
export function formatSwedishDate(isoDate: string): string {
  const d = new Date(`${isoDate}T12:00:00`)
  if (Number.isNaN(d.getTime())) return isoDate
  return d.toLocaleDateString('sv-SE', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  })
}
